import React, { useState } from "react";

//Assets 
import LogoCol from "../img/logo_colsubsidio.png";
import MainBk from "../img/puntos_interes/4.Fondo-PuntosdeInteres.jpg";
import ImageInnovaEdu from "../img/puntos_interes/4.Capsula-PI-Centrodeinnovacion.jpg";
import ImageFuturoComercio from "../img/puntos_interes/4.Capsula-PI-FuturoComercio.jpg";
import ImageBlocCasona from "../img/puntos_interes/4.Capsula-PI-BlocCasona.jpg";
import ImageMercadoDrogueria from "../img/puntos_interes/4.Capsula-PI-MercadoDrogueria.jpg";
import ImagePortalTrasmi from "../img/puntos_interes/4.Capsula-PI-PortalTrans.jpg";
import ImageVivero from "../img/puntos_interes/4.Capsula-PI-Vivero.jpg";

//Data Display
import TopLeftTitle from "../data_display/TopLeftTitle";
import ButtonLeftTitle from "../data_display/BottomLeftTitle";
import MiniaturePreview from "../data_display/MiniaturePreview";
import PointDefault from "../data_display/PointLocation";

//Inputs
import HomeButton from "../inputs/HomeButton";

//Navigation
import MenuMiniatures from "../navigation/MenuMiniatures";

const listMiniatures = [
{
    id: "1",
    title:"Portal Transmilenio",
    subtitle:"",
    image: ImagePortalTrasmi,
    x: "34%",
    y: "65%"
}, {
    id: "2",
    title:"Centro de Innovación Educativa",
    subtitle:"",
    image: ImageInnovaEdu,
    x: "20%",
    y: "36%"
}, {
    id: "3",
    title:"Bloc Casona",
    subtitle:"",
    image: ImageBlocCasona,
    x: "36%",
    y: "34%"
}, {
    id: "4",
    title:"Mercado Droguería",
    subtitle:"",
    image: ImageMercadoDrogueria,
    x: "27%",
    y: "38%"
}, {
    id: "5",
    title:"Futuro Comercio",
    subtitle:"",
    image: ImageFuturoComercio,
    x: "48%",
    y: "43%"
}, {
    id: "6",
    title:"Vivero",
    subtitle:"",
    image: ImageVivero,
    x: "41%",
    y: "33%"
}];

export default function PuntosInteresPage () {
    const [currentItem, SetCurrentItem] = useState(0);

    function onClickMiniature(tmpIndex)
    {
        SetCurrentItem(tmpIndex);
    }

    return (
        <div style={{width:"100%", height:"100%", backgroundImage:"url("+MainBk+")", backgroundSize:"contain"}}>
            <div style={{position:"absolute", right:"80px", top:"20px", width:"200px"}}>
                <img src={LogoCol} style={{width:"100%"}}/>
            </div>
            <TopLeftTitle title={"PUNTOS DE INTERÉS"} subtitle={"SERVICIOS Y DOTACIONALES"} />
            <ButtonLeftTitle title={"CIUDADELA"} subtitle={"15 MINUTOS"} />
            <HomeButton/>
            <MiniaturePreview item={listMiniatures[currentItem]}/>
            <MenuMiniatures items={listMiniatures} selected={currentItem} onClick={onClickMiniature}/>
            {
                listMiniatures.map((item, index)=>{
                    return (<PointDefault key={item.id} id={item.id} 
                        x={item.x} y={item.y} index={index}
                        onClick={onClickMiniature}
                        selected={index === currentItem ? true:false}
                        />
                    )
                })
            }
        </div>
    );
}